/**
 * This file is auto-generated from PatientMainChatItem.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const healed: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Healed';
        case 'pl':
            return 'Healed';
    }
};

export const you: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'You';
        case 'pl':
            return 'Ty';
    }
};

export const doctorPrefix: Translation<{ name: unknown }> = (lang, params) => {
    switch (lang) {
        case 'en':
            return ['Dr. ', params.name];
        case 'pl':
            return ['Dr ', params.name];
    }
};

export const attachedFiles: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Attached files';
        case 'pl':
            return 'Załączono pliki';
    }
};

export const doctorJoinNamed: Translation<{ name: unknown }> = (lang, params) => {
    switch (lang) {
        case 'en':
            return ['Doctor ', params.name, ' joined the chat'];
        case 'pl':
            return ['Lekarz ', params.name, ' dołączył/a do czatu'];
    }
};

export const documentParsed: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Document parsed';
        case 'pl':
            return 'Dokument przetworzony';
    }
};

export const profileDataRequested: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Please share your profile data';
        case 'pl':
            return 'Prosimy uzupełnić dane profilu';
    }
};

export const profileDataSent: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Profile data has been saved';
        case 'pl':
            return 'Dane profilu zostały zapisane';
    }
};

export const subscriptionRequested: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Subscription has been requested';
        case 'pl':
            return 'Subskrypcja została zamówiona';
    }
};

export const subscriptionStarted: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Subscription has been activated';
        case 'pl':
            return 'Subskrypcja została aktywowana';
    }
};

export const chatEnded: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Chat ended';
        case 'pl':
            return 'Czat zakończony';
    }
};
